<template>
  <v-row>
    <v-col cols="12">
      <div v-if="local_video_src" class="d-flex flex-column align-start">
        <video :src="local_video_src" controls class="supporter-video mb-2 elevation-2"></video>

        <v-btn color="primary" :href="local_video_src" target="_blank" download>
          <v-icon left>mdi-download</v-icon>
          Download
        </v-btn>
      </div>
    </v-col>
    <v-col cols="12">
      <v-file-input accept="video/*" placeholder="Select your video" prepend-icon="mdi-video" ref="video" label="Video"
        dense v-model="selected_file" @change="updateVideo"></v-file-input>
    </v-col>
  </v-row>
</template>

<script>
import { authHeader } from '../../../_helpers';

export default {
  name: "SupporterVideo",
  props: ['personal_information'],
  data() {
    return {
      img_base_url: process.env.VUE_APP_IMG_BASE_URL,
      selected_file: null
    }
  },
  computed: {
    local_video_src() {
      const videoUrl = this.personal_information.video_url
      if (!videoUrl)
        return ''

      if (/^https?:\/\//.test(videoUrl))
        return videoUrl

      return `${this.img_base_url}/uploads/supporters/${videoUrl}`
    }
  },
  methods: {
    async updateVideo() {
      try {
        if (!this.selected_file)
          return false
        else {
          await this.removeVideo();
          let formData = new FormData()
          await formData.append('profile', this.selected_file)

          const upload_result = await this.$http.post('/back-office/supporters/video', formData, authHeader())
          if (upload_result) {
            this.personal_information.video_url = upload_result.data.file_name
            this.selected_file = null
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    async removeVideo() {
      try {
        if (!this.personal_information.video_url || /^https?:\/\//.test(this.personal_information.video_url))
          return;
        else {
          let fileName = this.personal_information.video_url.split('/').pop()
          await this.$http.delete(`/back-office/supporters/video/${fileName}`, authHeader())
          this.personal_information.video_url = null
          return;
        }
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>

<style scoped>
.supporter-video {
  width: 100%;
  max-width: 300px;
  max-height: 300px;
  background-color: #000;
}
</style>
